import {
  pgTable, uuid, text, timestamp, integer, boolean, jsonb, index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Qualification Rules — Event-Agnostic Lead Scoring (S.8)
// ---------------------------------------------------------------------------
// Tenant-configurable rules that score contacts from ANY qualifying event:
// form.submitted, booking.walk_in, call.logged, custom_event.*, etc.
// The PI.2 qualification engine evaluates matching rules and updates
// people.qualificationScore / qualificationTier.

export const qualificationRules = pgTable("qualification_rules", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  name: text("name").notNull(),
  triggerEvent: text("trigger_event").notNull(), // event type that activates this rule
  scoringConfig: jsonb("scoring_config").$type<{
    fields: Array<{ fieldKey: string; weight: number; scores: Record<string, number> }>;
    tiers: Array<{ name: string; minScore: number }>;
    signalCategories: Array<{ name: string; fields: string[] }>;
  }>().notNull(),
  isActive: boolean("is_active").notNull().default(true),
  priority: integer("priority").notNull().default(0), // lower = evaluated first
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_qual_rules_tenant").on(table.tenantId),
  index("idx_qual_rules_trigger").on(table.tenantId, table.triggerEvent),
]);
